export const martaMalecka = {
    'firstName': 'Marta',
    'lastName': 'Małecka',
    'profession': 'Seksuolog, psychoterapeuta',
    'avatar': 'marta-malecka.webp',
    'slug': 'seksuolog-psychoterapeuta-marta-malecka',
    'locations': ['torun'],
    'services': [
        ['sexuology', 'consultation'],
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'children'],
    ]
}